<template>
    <div v-if="thingsToKnow">
        <h5 class="mb-4">Things to Know</h5>
        
        <container>
            <row>
                <column :md="12" :lg="8" v-if="firstThirdList">
                    <things-to-know-item v-for="(item, index) in firstThirdList" :key="`things-to-know-1-${property.id}-${index}`" :item="item" class="mb-4 pb-4" />
                </column>

                <column :md="12" :lg="8" v-if="secondThirdList">
                    <things-to-know-item v-for="(item, index) in secondThirdList" :key="`things-to-know-2-${property.id}-${index}`" :item="item" class="mb-4 pb-4" />
                </column>

                <column :md="12" :lg="8" v-if="thirdThirdList">
                    <things-to-know-item v-for="(item, index) in thirdThirdList" :key="`things-to-know-3-${property.id}-${index}`" :item="item" class="mb-4 pb-4" />
                </column>
            </row>
        </container>
    </div>
    <div v-else-if="!error && !emptyResults" class="text-center p-5">
        <spinner size="lg"/>
    </div>
</template>

<script type="text/javascript">
    import CommonComponents from '@/components/Common.vue';
    import ThingsToKnowItem from '@/components/Content/Public/Properties/ThingsToKnow/Item.vue';
    import ApiObject from '@/classes/ApiObject.js';
    import ApiConfig from '@/config/api.json';

    import { UseApiStore } from '@/store/Api.js';
    import { UseUIStore } from '@/store/UI.js';

    export default {
        components: {
            ThingsToKnowItem,
            ...CommonComponents,
        },

        setup() {
            return {
                apiStore: UseApiStore(),
                uiStore: UseUIStore(),
            };
        },

        data() {
            return {
                error: null,
                disposed: false,
                emptyResults: null,
                requestsTimer: null,
            };
        },

        created() {
            this.requestData();
        },

        beforeUnmount() {
            clearTimeout(this.requestsTimer);
            this.disposed = true;
        },

        props: {
            property: {
                type: ApiObject,
                required: true,
            },

            offer: {
                type: ApiObject,
            },

            thirdPartyRates: {
                type: Boolean,
                default: false,
            },
        },

        computed: {

            requestUrl() {
                let url = 'properties/'+this.property.id+'/things-to-know';
                if (this.offer) {
                    url += '?offerId='+this.offer.id;
                    if (this.thirdPartyRates) {
                        url += '&lease=1';
                    }
                }
                else if (this.thirdPartyRates) {
                    url += '?lease=1';
                }
                
                return url;
            },
            
            thingsToKnow() {
                let response = this.apiStore.requests[this.requestUrl];
                
                if (!response) {
                    return null;
                }

                if ((response.valid) && (response.results) && (!response.results.error)) {
                    if ((response.results.thingsToKnow) && (response.results.thingsToKnow.length)) {
                        return response.results.thingsToKnow;
                    }
                    else {
                        this.setEmptyResults(true);
                        return null;
                    }
                }
                else {
                    let error = 'Could not complete request';
                    if ((response.results) && (response.results.error)) {
                        if (response.results.error.message) error = response.results.error.message;
                        else error = response.results.error;
                    }
                    this.setError(error);
                }
                
                return null;
            },

            divideListsBy() {
                if (this.uiStore.isMobile) {
                    return 1;
                }
                else if (this.uiStore.isTablet) {
                    return 2;
                }
                return 3;
            },
            
            firstThirdList() {
                if (this.thingsToKnow) {
                    if (
                        (!this.uiStore.isMobile) &&
                        (this.thingsToKnow.length >= this.divideListsBy)
                    ) {
                        let num = Math.ceil(this.thingsToKnow.length / this.divideListsBy);
                        return this.thingsToKnow.slice(0, num);
                    }
                    else {
                        return this.thingsToKnow;
                    }
                }

                return null;
            },

            secondThirdList() {
                if (this.uiStore.isMobile) {
                    return null;
                }
                if (
                    (this.thingsToKnow) &&
                    (this.thingsToKnow.length >= this.divideListsBy)
                ) {
                    let num = Math.ceil(this.thingsToKnow.length / this.divideListsBy);
                    return this.thingsToKnow.slice(num, num * 2);
                }

                return null;
            },

            thirdThirdList() {
                if (
                    (this.uiStore.isMobile) ||
                    (this.uiStore.isTablet)
                ) {
                    return null;
                }

                if ((this.thingsToKnow) && (this.thingsToKnow.length >= this.divideListsBy)) {
                    let num = Math.ceil(this.thingsToKnow.length / this.divideListsBy);
                    return this.thingsToKnow.slice(num * 2);
                }

                return null;
            },
        },

        methods: {


            async requestData() {
                if (this.disposed) return;
                
                this.setError(null);
                this.setEmptyResults(null);
                
                clearTimeout(this.requestsTimer);

                await this.apiStore.get(this.requestUrl);

                this.requestsTimer = setTimeout(this.requestData, ApiConfig.dashboardLongCache * 1000);
            },

            setError(error) {
                this.error = error;
            },
            
            setEmptyResults(val) {
                this.emptyResults = val;
            },
        }
    };

</script>
